import { usePrompts, useStartNewChat, useTextChat } from '@mint-lib/ai-chat';
import { Card, typographyVariants } from '@mint-lib/tw-components';
import { cn } from '@mint-lib/tw-utils';

import { aiMetadataTemplates } from '../../../features/MetadataCollector/metadataTemplates.js';
import useAgenticChat from '../../../hooks/useAgenticChat.js';

type Props = {
  isFullScreen: boolean;
};

const SuggestedPrompts = ({ isFullScreen }: Props) => {
  const { setChatSessionId } = useAgenticChat();
  const { isAiProcessing: isAiProcessingText } = useTextChat();

  const { desktopPrompts } = usePrompts();
  const { startNewChat } = useStartNewChat();

  const handleStartNewChat = async (text: string) => {
    const chat = await startNewChat(aiMetadataTemplates.agentic, { text });
    setChatSessionId(chat.chatSessionId);
  };

  return (
    <div
      className={cn(
        'grid h-50 w-full place-items-center gap-6',
        isFullScreen ? 'max-w-full grid-cols-3' : 'max-w-full grid-cols-2',
      )}
    >
      {desktopPrompts.map((prompt) => (
        <div
          key={prompt.question}
          className={cn(
            'flex h-full w-full min-w-55.5 grow-0 rounded-xl bg-transparent p-px text-icon-primary',
            isFullScreen ? 'max-w-66.75' : 'max-w-55.5',
          )}
        >
          <Card
            disabled={isAiProcessingText}
            onClick={() => handleStartNewChat(prompt.question)}
            className="!important items-self-center relative m-0 flex h-16 w-full max-w-66.25 min-w-55 cursor-pointer flex-col items-start self-center overflow-hidden rounded-xl border border-solid border-ui-tertiary"
            contentClassName="flex flex-col gap-2"
          >
            <div className="mb-0 flex flex-col self-start">{prompt.icon}</div>
            <p className={cn(typographyVariants({ variant: 'caption2' }))}>
              {prompt.question}
            </p>
          </Card>
        </div>
      ))}
    </div>
  );
};

export default SuggestedPrompts;
